import styled from 'styled-components';
import { BLACK, WHITE } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Wrap = styled.section`
  max-width: 1060px;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  padding: 0 20px;
  ${media.tabletL`
    padding: 0;
  `};
`;

export const Title = styled.h5`
  position: relative;
  margin: 0 0 60px;
  text-align: center;

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BLACK};
    height: 3px;
    width: 40px;
  }
`;

export const SubTitle = styled.h6`
  margin: 30px auto 20px;
  text-align: center;
  font-size: 14px;
`;
export const StepWrap = styled.ul`
  margin: 0 auto 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  > i {
    display: none;
  }
  ${media.tabletL`
    flex-direction: row;
  `};
`;
export const Steplist = styled.li`
  list-style-type: none;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  display: flex;
  ${media.tabletL`
    margin-right: 30px;
    &:last-child {
      margin-right: 0;
    }
  `};
`;
export const TopicsWrap = styled.ul`
  overflow: hidden;
`;
export const TopicsList = styled.li`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  list-style-type: none;
  margin-bottom: 60px;
  ${media.tabletL`
    flex-direction: row;
  `};
  > div {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    ${media.tabletL`
      padding-right: 40px;
      max-width: 650px;
    `};
    > h6 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    > p {
      margin: 3px 0;
      padding: 0;
      font-size: 14px;
      > p {
        > img {
          display: block;
          margin: 5px auto 20px;
          max-width: 100%;
          ${media.tabletL`
            margin: 5px 0 20px;
          `};
        }
        > a {
          text-decoration: underline;
        }
      }
    }
    > p:last-child() {
      margin-top: 30px;
    }
  }
  > img {
    display: block;
    margin: 0 auto;
    width: 80%;
    ${media.tabletL`
      // margin-right: 0;
      margin: 0;
      width: 360px;
      height: 260px;
    `};
  }
`;
export const ButtonText = styled.a`
    background-color: #000;
    border: none;
    color: #ffffff;
    cursor: pointer;
    display: block;
    font-size: 14px;
    font-weight: 800;
    text-align: center;
    height: 60px;
    -webkit-letter-spacing: 1px;
    -moz-letter-spacing: 1px;
    -ms-letter-spacing: 1px;
    letter-spacing: 1px;
    line-height: 60px;
    margin: 20px auto 0;
    max-width: 340px;
    width: 100%;
    outline: none;
    &:active, &:hover {
      color: ${WHITE};
    }
}



  ${media.tabletL`
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 20px 0;
  `};
`;

export const Text = styled.p`
  color: ${BLACK};
  h1,
  h2,
  h3,
  p {
    font-size: 14px;
    line-height: 1.5em;
    font-weight: 400;
    margin: 0 0 20px 0;
    &:last-child {
      margin-bottom: 0;
    }
  }
  img: {
    max-width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/Application/Application.style.js